"use client";

import { useState } from "react";
import { TeamMember } from "../../data/dataMembers";

export default function ClientDynamicSection({ member }: { member: TeamMember }) {
  const [active, setActive] =
    useState<"bio" | "education" | "experience" | "admissions">("bio");

  const sections = {
    bio: { title: "About", content: [member.bio] },
    education: { title: "Education", content: member.education },
    experience: { title: "Previous Experience", content: member.previousExperience },
    admissions: { title: "Professional Admissions", content: member.admissions },
  };

  const section = sections[active];

  return (
    <div className="flex flex-col md:flex-row gap-10 w-full px-4 lg:px-30">

      {/* Mobile Tabs (horizontal scroll) */}
      <div className="block md:hidden w-full overflow-x-auto pb-3 mt-6">
        <ul className="flex gap-6 min-w-max border-b">
          {Object.keys(sections).map((key) => (
            <li
              key={key}
              className={`cursor-pointer pb-2 transition-colors whitespace-nowrap ${
                active === key
                  ? "text-primary border-b-2 border-primary font-semibold"
                  : "text-gray-500 hover:text-black"
              }`}
              onClick={() => setActive(key as keyof typeof sections)}
            >
              {sections[key as keyof typeof sections].title}
            </li>
          ))}
        </ul>
      </div>

      {/* Desktop Sidebar Menu */}
      <div className="hidden md:block w-full md:w-[260px] lg:w-[300px] mt-12 md:mt-0">
        <ul className="space-y-6">
          {Object.keys(sections).map((key) => (
            <li
              key={key}
              className={`cursor-pointer pb-2 border-b transition-colors ${
                active === key
                  ? "border-[#a6192e] text-[#a6192e] font-semibold"
                  : "border-gray-300 text-gray-500 hover:text-black"
              }`}
              onClick={() => setActive(key as keyof typeof sections)}
            >
              {sections[key as keyof typeof sections].title}
            </li>
          ))}
        </ul>
      </div>

      {/* Main Content */}
      <div className="flex-1 transition-all duration-300 mt-4 md:mt-0">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 text-black">
          {section.title}
        </h2>

        <ul className="space-y-3 text-gray-700 text-base sm:text-lg">
          {section.content.map((item, index) => (
            <li key={index} className="leading-relaxed">
              {typeof item === "string" ? (
                item
              ) : (
                <div>
                  <strong>{item.title}</strong>
                  <p className="mt-1">{item.description}</p>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>

    </div>
  );
}
